import React from "react";

import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../../css/Admin.css";

import MultiSelectDropdown from "./customComponents/MultiSelectDropdown";

/**
 * Change the following variables to modify MultiselectDropdown component's items
 */

const baseUrl = "http://localhost:52344";
const loadUrl = `${baseUrl}/geoelementmicroservice/zone`;
const ids = [
  "65673200-1aab-41a6-a670-3fe015e5f4a3",
  "9d96e30d-6e1e-4437-8542-b30b0aa9bdd8",
];
class TrialPage extends React.Component {
  const;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <span>
          This is a trial page that can be used for testing
          features,components,..
        </span>
        <ul>
          <li>
            <div>
              <h4> Multiselect Dropdown </h4>
              <MultiSelectDropdown
                loadUrl={loadUrl}
                idsSelected={ids}
                idColumnName="geoElementId"
              />
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default TrialPage;
